import { _ } from "i18n";

/**
 * `swapped` has three states rather than two: null means the Sportlogiq lambda has not reported on
 * the analysis yet, which is not the same as it reporting that no swap happened.
 */
export function formatSwappedState(swapped: string | number | boolean | null | undefined): string {
	if (swapped == null) {
		return _("game.swapped.notReported");
	}

	if (swapped === true) {
		return _("app.eyeball.yes");
	}

	return _("app.eyeball.no");
}
